import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/svg/business-img.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_2 = { class: "business-modal__text" }
const _hoisted_3 = {
  href: "https://yolllobusiness.com/",
  class: "page-btn",
  target: "_blank"
}

import { useI18n } from "vue-i18n";
import { EventsEnum } from "@/utils/enum/general/eventsEnum";
import AppModal from "../../slots/modals/AppModal.vue";
import AppModalImage from "@/components/slots/modals/AppModalImage.vue";
import AppModalTitle from "@/components/slots/modals/AppModalTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'JoinBusinessModal',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppModal, {
    class: "business-modal",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(_unref(EventsEnum).CLOSE)))
  }, {
    default: _withCtx(() => [
      _createVNode(AppModalImage, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(AppModalTitle, { class: "popup__title" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("business-modal-phrase-1")), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)("business-modal-phrase-2")), 1),
      _createElementVNode("a", _hoisted_3, _toDisplayString(_unref(t)("business-modal-phrase-3")), 1)
    ]),
    _: 1
  }))
}
}

})